<template>
  <div class="primary pa-5 mb-5">
    <confirm-modal
        v-model="modalExcluir"
        @modalAcaoCancelar="fecharModalExcluir"
        @modalAcaoConfirmar="excluirPacienteSelecionado"
        :persistencia="false"
        mensagemInicial="Deseja realmente excluir o paciente "
        :mensagemMeio="paciente.nome"
        mensagemFinal="?"/>
    <QRCodeModal
        v-if="modalQRCode"
        v-model="modalQRCode"
        titulo="QR Code ficha de paciente"
        :textoQRCode="QRCodeFicha"
        @modalQRCodeFechar="fecharModalQRCode"
    />
    <v-row class="pl-5" cols="12" md="6">
      <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
        <span class="font-weight-bold">Paciente</span>
        <p class="mb-0 text-truncate">{{ paciente.nome | textoSemValor }}</p>
      </v-col>
      <v-col class="headerCabecalho pl-0 pr-0" md="1" sm="1" xs="6">
        <span class="font-weight-bold">Sexo</span>
        <p class="mb-0">{{ paciente.sexoNome }}</p>
      </v-col>
      <v-col class="headerCabecalho pl-0 pr-0" md="1" sm="1" xs="6">
        <span class="font-weight-bold">Idade</span>
        <p class="mb-0">{{ paciente.idade }}</p>
      </v-col>
      <v-col class="headerCabecalho pl-0" md="1" sm="1" xs="6">
        <span class="font-weight-bold">Ortodontia</span>
        <p class="mb-0 text-truncate">{{ paciente.ortodontia ? 'Sim' : 'Não' }}</p>
      </v-col>
      <v-col class="headerCabecalho pl-0" md="1" sm="1" xs="6">
        <span class="font-weight-bold">Implante</span>
        <p class="mb-0 text-truncate">{{ paciente.implante ? 'Sim' : 'Não' }}</p>
      </v-col>
      <v-col class="headerCabecalho pl-0" md="2" sm="2" xs="6">
        <span class="font-weight-bold">Cidade</span>
        <p class="mb-0 text-truncate">{{ paciente.cidade | textoSemValor }} - {{ paciente.estado | textoSemValor }}</p>
      </v-col>
      <v-col class="headerCabecalho" md="4" sm="4" xs="6">
        <div class="ficha-header-actions">
          <div class="mr-10">
            <botao-imprimir outlined :disabled="!paciente.id" @baixarRelatorio="relatorioFichaPaciente(true)"
                            @gerarRelatorio="relatorioFichaPaciente(false)"/>
          </div>
          <v-tooltip top v-if="paciente.telefone">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon class="mr-3" @click="enviarMensagemViaWhatsapp">
                <v-icon large color="white">mdi-whatsapp</v-icon>
              </v-btn>
            </template>
            Enviar mensagem por WhatsApp
          </v-tooltip>
          <botao-gerar-q-r-code outlined :disabled="!paciente.id" @modalQRCode="abrirModalQRCode" class="mr-3"/>
          <botao-adicionar-sala-espera class="mr-3" outlined :disabled="!paciente.id"
                                       @adicionarSalaEspera="enviarSalaEspera"/>
          <botao-editar outlined :disabled="!paciente.id" @editar="editarPaciente"/>
          <botao-excluir :disabled="!paciente.id" @excluir="abrirModalExcluir" class="ml-5"/>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BotaoEditar from '@/views/components/BotaoEditar'
import BotaoExcluir from '@/views/components/BotaoExcluir'
import BotaoImprimir from '@/views/components/BotaoImprimir.vue'
import BotaoAdicionarSalaEspera from '@/views/components/BotaoAdicionarSalaEspera.vue'
import BotaoGerarQRCode from '@/views/components/BotaoGerarQRCode.vue'
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import QRCodeModal from '@/views/components/QRCodeModal.vue'
import {actionTypes} from '@/core/constants'

export default {
    name: 'PacienteFichaCabecalho',
    components: {
        QRCodeModal,
        ConfirmModal,
        BotaoGerarQRCode, BotaoAdicionarSalaEspera, BotaoImprimir, BotaoExcluir, BotaoEditar
    },
    props: {
        paciente: {
            required: true
        }
    },
    data() {
        return {
            modalExcluir: false,
            modalQRCode: false,
            QRCodeFicha: null
        }
    },
    methods: {
        editarPaciente() {
            this.$router.push({name: 'PacienteEdicao', params: this.paciente.id})
        },
        async relatorioFichaPaciente(baixar) {
            await this.$store.dispatch(actionTypes.RELATORIOS.GERAR_RELATORIO_FICHA_PACIENTE, {
                pacienteId: this.paciente.id,
                nomePaciente: this.paciente.nome,
                baixar: baixar
            })
        },
        async enviarSalaEspera() {
            this.setMensagemLoading('Adicionando paciente a sala de espera...')
            await this.$store.dispatch(actionTypes.SALA_ESPERA.ADICIONAR_PACIENTE, this.paciente.id)
            this.mostrarNotificacaoSucessoDefault()
        },
        enviarMensagemViaWhatsapp() {
            const url = `https://api.whatsapp.com/send?phone=55${this.paciente.telefone}`
            window.open(url, '_blank')
        },
        abrirModalQRCode() {
            this.QRCodeFicha = window.location.href
            this.modalQRCode = true
        },
        fecharModalQRCode() {
            this.modalQRCode = false
            this.QRCodeFicha = null
        },
        fecharModalExcluir() {
            this.modalExcluir = false
        },
        abrirModalExcluir() {
            this.modalExcluir = true
        },
        async excluirPacienteSelecionado() {
            await this.$store.dispatch(actionTypes.CADASTROS.PACIENTE.EXCLUIR_PACIENTE, this.paciente.id)
            this.fecharModalExcluir()
            this.$router.push(this.$store.state.paciente.rotaOrigem)
            this.mostrarNotificacaoSucessoDefault()
        },
    }
}
</script>

<style scoped lang="stylus">
.headerCabecalho
  font-size 0.9em
  color white
  max-height 90px

.reabrirIncorporacao
  opacity 0.3
  font-size 15px

.ficha-header-actions
  margin-right 5px
  display flex
  flex-direction row
  justify-content flex-end

</style>
